import { AuthService } from '@teko/auth';
import { NotificationService } from '@teko/notification';
import { unregisterUNS } from '../modules/notification/helper';
import {
  LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
} from '../constants';

// THIS FUNCTION IS TO BE DEPRECATED
// DO NOT USE THIS IN NEW CODE
// TO REMOVE IT SOON
const LOCALSTORAGE_ACCESS_TOKEN = 'ACCESS_TOKEN';

export function getAccessToken() {
  let accessToken,
    isLoggedIn = false;
  accessToken = window?.TekoID?.user?.getAccessToken();
  if (!accessToken) {
    // for ibanking flow
    // accessToken is stored in localStorage
    // hence IAM sdk would not return proper result
    // when check expiry via user.isLoggedIn();
    // thus, we always assume it's not yet expired.
    accessToken = localStorage?.getItem(LOCALSTORAGE_ACCESS_TOKEN);
    isLoggedIn = true;
  } else {
    isLoggedIn = !!window?.TekoID?.user?.isLoggedIn();
  }
  if (accessToken && isLoggedIn) return accessToken;
}

export function getIdToken() {
  // not support ibanking flow
  // should support later
  // TODO: should check carefully with ibanking
  if (typeof window !== 'undefined') {
    return window?.TekoID?.user?.loadUser()?.idToken;
  }
  return;
}

export const clearStorageOnSignout = () => {
  [
    LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
    LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  ].forEach((lsKey) => localStorage.removeItem(lsKey));
};

export const onSignOut = async (
  authService: AuthService,
  notificationService: NotificationService,
  notificationAppId: string,
  redirectUrl?: string,
): Promise<void> => {
  unregisterUNS(notificationService, notificationAppId);
  authService.logout(redirectUrl);
  clearStorageOnSignout();
};
